import { render, staticRenderFns } from "./XiangMu2.vue?vue&type=template&id=05b3743c&scoped=true"
import script from "./XiangMu2.vue?vue&type=script&lang=js"
export * from "./XiangMu2.vue?vue&type=script&lang=js"
import style0 from "./XiangMu2.vue?vue&type=style&index=0&id=05b3743c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3743c",
  null
  
)

export default component.exports